<script>
	// NPM Modules
	import dayjs from 'dayjs';
	// Stores
	import PromotionStore from '@/Stores/PromotionStore';
	import UserStore from '@/Stores/UserStore';
	// Components
	import Modal from '@/Components/ModalFlex.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import Prompt from '@/Components/Prompt.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';
	import TextInput from '@/Components/NewTextInput.svelte';
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';
	// Constants
	import { PromotionsType } from '@/Constants/Promotions.js';

	export let open = false;
	export let user;

	let sending = false;
	let promotionId = false;
	let checkValue = false;
	let searchText = '';
	let loading = false;

	$: open;
	$: promotionOption = $PromotionStore && $PromotionStore.sortBy('name').all();
	$: showCampaigns = false;
	$: (showCampaigns || !showCampaigns) && performSearch();

	PromotionStore.getPromotions(
		[PromotionsType.NextDepositMatch],
		true,
		{ perPage: 500, page: 1 },
		false,
		showCampaigns
	);

	function performSearch() {
		if (searchText !== '') {
			searchPromotion(searchText);
		} else {
			clearSearch();
		}
	}

	function addPromoToUser() {
		if (promotionId) {
			sending = true;
			let promotion = $PromotionStore.firstWhere('id', promotionId);
			if (parseInt(promotion.rules.max_bonus_amount) > 99999) {
				checkValue = true;
			} else {
				doPromoAddToUser(promotionId);
			}
		}
	}

	function doPromoAddToUser(promotionId) {
		PromotionStore.addPromoToUser(user, promotionId)
			.then(() => {
				notify({
					type: 'success',
					title: 'Promotion added',
					message: 'The promotion was successfully added to the user.',
					timeout: 3
				});
				UserStore.getUserWithDetails(user.id);
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Problem adding promotion',
					message: e.error[0] || 'Problem adding promotion to user',
					timeout: 5
				});
			})
			.finally(() => {
				sending = false;
				open = false;
			});
	}

	async function searchPromotion(keyword) {
		loading = true;
		await PromotionStore.searchPromotion(
			keyword,
			[PromotionsType.NextDepositMatch],
			{ perPage: 500, page: 1 },
			true,
			false,
			showCampaigns
		);
		loading = false;
		return $PromotionStore.sortBy('name').sortBy('created_at').all();
	}
	async function clearSearch() {
		loading = true;
		searchText = '';
		await PromotionStore.getPromotions(
			[PromotionsType.NextDepositMatch],
			true,
			{ perPage: 500, page: 1 },
			false,
			showCampaigns
		);
		loading = false;
		return $PromotionStore.sortBy('name').sortBy('created_at').all();
	}
</script>

{#if checkValue}
	<Prompt
		bind:open={checkValue}
		title="Confirm promotion value"
		message="The bonus allocation seems high, Are you sure you want to go ahead?"
		onConfirm={() => doPromoAddToUser(promotionId)}
		on:close={() => {
			sending = false;
		}}
	/>
{/if}
{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">
			Add Promotion to {user.name} - {user.full_name}
		</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center justify-center">
			<div class="flex items-center justify-end p-1 mb-2">
				<div class="mr-1">Show Campaigns</div>
				<Switch name="showCampaigns" bind:checked={showCampaigns} />
			</div>
			<div class="flex flex-row text-left mb-1">
				<span>Search promotions by name or code</span>
			</div>
			<div class="flex flex-row mb-4 space-x-1 text-left">
				<TextInput
					className="pr-0.5 w-4/5"
					name="searchText"
					bind:value={searchText}
					placeholder="A search here will reload the dropdown below"
					label=""
				/>
				<LoadingButton
					{loading}
					on:click={() => searchPromotion(searchText)}
					class="flex flex-grow items-center justify-center btn btn-primary"
				>
					<span>search</span>
				</LoadingButton>
				<LoadingButton
					disabled={loading}
					on:click={clearSearch}
					class="flex flex-grow items-center justify-center btn btn-danger"
				>
					<span>Clear</span>
				</LoadingButton>
			</div>
			<hr />
			<SelectInput
				label="Select promotion to add to user"
				className="flex flex-col py-1 my-4 justify-center text-left"
				name="promotionId"
				disabled={loading}
				required={true}
				bind:value={promotionId}
			>
				<option value={false} disabled selected>Select Promotion...</option>
				{#each promotionOption as promotion (promotion.id)}
					{#if promotion.id == parseInt(promotionId)}
						<option value={promotion.id} selected>{promotion.name}</option>
					{:else}
						<option value={promotion.id}
							>{promotion.name} - {promotion.code}; TYPE={promotion.promotion_type.name}; EXPIRES={promotion.never_expire
								? 'Never'
								: dayjs(promotion.expired_at).format('D MMM YYYY, HH:mm')}
						</option>
					{/if}
				{/each}
			</SelectInput>
			<LoadingButton on:click={addPromoToUser} disabled={loading} loading={sending} className="mb-4 btn btn-primary">
				Add to user
			</LoadingButton>
			<LoadingButton class="mb-4 btn btn-muted" {loading} on:click={() => (open = false)}>Cancel</LoadingButton>
		</div>
	</Modal>
{/if}
